import { scaleGuide } from "@/data/fruits";

export const ScaleGuide = () => (
  <section className="rounded-2xl border border-[#E5E1D8] bg-white p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)] sm:p-7" data-testid="reflection-scale-guide-section">
    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="reflection-scale-guide-overline">Scale meaning</p>
    <h2 className="mt-2 font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid="reflection-scale-guide-title">A prayerful 1–5 assessment</h2>
    <div className="mt-5 grid gap-3 sm:grid-cols-5" data-testid="reflection-scale-guide-list">
      {scaleGuide.map((item) => (
        <div key={item.score} className="rounded-xl border border-[#E5E1D8] bg-[#F9F6F0] p-3" data-testid={`reflection-scale-guide-${item.score}`}>
          <p className="font-serif-display text-3xl font-semibold text-[#1A3626]" data-testid={`reflection-scale-guide-${item.score}-score`}>{item.score}</p>
          <p className="mt-1 text-sm leading-snug text-[#4A5D4E]" data-testid={`reflection-scale-guide-${item.score}-label`}>{item.label}</p>
        </div>
      ))}
    </div>
  </section>
);